import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const ProfilesList = lazy(() => import('./profiles/List'))
const ProfileEdit = lazy(() => import('./profiles/Edit'))
const PayloadsCatalog = lazy(() => import('./payloads/Index'))
const AppsList = lazy(() => import('./apps/List'))
const PackagesList = lazy(() => import('./packages/List'))
const Dashboard = lazy(() => import('./dashboard/Index'))
const AuditLog = lazy(() => import('./audit-log/Index'))
const EnrollmentDetail = lazy(() => import('./enrollments/Detail'))
const VppIndex = lazy(() => import('./vpp/Index'))
const ScheduledCommands = lazy(() => import('./scheduled/Index'))
const SmartGroups = lazy(() => import('./groups/Index'))

export const MdmRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings', 'role--settings--mdm']}>
    <Route index element={<Index />} />
    <Route path='dashboard' element={<Dashboard />} />
    <Route path='audit-log' element={<AuditLog />} />
    <Route path='enrollments/:id' element={<EnrollmentDetail />} />
    <Route path='profiles' element={<ProfilesList />} />
    <Route path='profiles/new' element={<ProfileEdit />} />
    <Route path='profiles/:id' element={<ProfileEdit />} />
    <Route path='payloads' element={<PayloadsCatalog />} />
    <Route path='apps' element={<AppsList />} />
    <Route path='packages' element={<PackagesList />} />
    <Route path='vpp' element={<VppIndex />} />
    <Route path='scheduled' element={<ScheduledCommands />} />
    <Route path='groups' element={<SmartGroups />} />
  </SubRouter>
))
